import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableHeadConfiguration, TableHeadTool } from '../table-display/table-head-tool';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { ThisPlatformService } from '../../_services/this-platform.service';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss']
})
export class TableHeaderComponent implements OnInit {

  @Input()
  config: TableHeadConfiguration;

  @Output()
  onSearchText = new EventEmitter<string>();

  searchText$ = new Subject<string>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public p: ThisPlatformService,
  ) { }

  ngOnInit() {
    if(this.config.searchTool) {
      this.config.searchTool.text = ( this.config.searchTool.text || '' );
      this.searchText$.next(this.config.searchTool.text);
    }

    // setting delay for emitting text to filter
    this.searchText$.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      filter(text => text.length === 0 || text.length >= this.getMinSearchLength())
    )
    .subscribe(
      () => {
        this.onSearchText.emit()
      }
    );
  }

  resolveToolClick($event, tht: TableHeadTool) {
    if (tht.click) {
      tht.click();
    } else {
      this.router.navigate([tht.link], { queryParams: tht.queryParams, relativeTo: this.route });
    }
  }

  /**
   * Reads the value from $event (not tool.text) on purpose: with [(ngModel)] + an explicit
   * (ngModelChange) on the same input, listener execution order is template-order dependent,
   * so tool.text can still hold the previous keystroke's value when this runs.
   */
  getTrim(tool: TableHeadTool, value: string) {
    tool.text = ( value ? value.trim() : '' );
    this.searchText$.next(tool.text)
  }

  /** Opt-in per view via config.searchTool.minSearchLength — 0 (no minimum) if not configured */
  getMinSearchLength(): number {
    return this.config?.searchTool?.minSearchLength ?? 0;
  }

  ngOnDestroy() {
    this.searchText$.unsubscribe();
  }

}
